
import { defineComponent } from "vue";
export default defineComponent({
  name: "SelectDialog",
  props: {
    title: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:modelValue", "cancel"],
  methods: {
    modelValueChange(value: string) {
      this.$emit("update:modelValue", value);
    },
  },
});
